import React, { useState, useRef, useEffect } from "react";
import { Globe } from "lucide-react"; // 아이콘 라이브러리 사용 (lucide-react)
import { useLang } from "../context/LangProvider";

export default function LanguageDropdown() {
  const { i18n, setLang, lang } = useLang(); // LangProvider에서 현재 언어/변경함수 가져오기
  const [open, setOpen] = useState(false);
  const ref = useRef(null);

  const handleToggle = () => setOpen((prev) => !prev);

  const handleSelect = (code) => {
    setLang(code);
    setOpen(false);
  };

  // 바깥 클릭 시 닫기
  useEffect(() => {
    const onClickOutside = (e) => {
      if (ref.current && !ref.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener("click", onClickOutside);
    return () => document.removeEventListener("click", onClickOutside);
  }, []);

  return (
    <div ref={ref} className="lang-dropdown" style={{ position: "relative" }}>
      <button
        type="button"
        className="link-btn"
        onClick={handleToggle}
        aria-label={i18n("common.language")}
      >
        <Globe size={20} strokeWidth={1.8} style={{ color: "#6f6963" }} />
      </button>

      {open && (
        <div
          className="lang-menu"
          style={{
            position: "absolute",
            top: "110%",
            right: 0,
            background: "white",
            border: "1px solid #ddd",
            boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
            borderRadius: "6px",
            overflow: "hidden",
            zIndex: 10,
          }}
        >
          <button
            type="button"
            onClick={() => handleSelect("ko")}
            className="lang-item"
            style={{
              padding: "8px 16px",
              width: "100%",
              textAlign: "left",
              background: lang === "ko" ? "#f9f9f9" : "white",
              borderBottom: "1px solid #eee",
            }}
          >
            한국어
          </button>
          <button
            type="button"
            onClick={() => handleSelect("en")}
            className="lang-item"
            style={{
              padding: "8px 16px",
              width: "100%",
              textAlign: "left",
              background: lang === "en" ? "#f9f9f9" : "white",
            }}
          >
            English
          </button>
        </div>
      )}
    </div>
  );
}
